import { api } from './client';
import type { LoginRequest, User } from './types';

export interface SsoStatus {
  enabled: boolean;
}

export const authApi = {
  login:  (payload: LoginRequest) => api.post<User>('/auth/login', payload),
  logout: ()                      => api.post<void>('/auth/logout'),
  me:     ()                      => api.get<User>('/auth/me'),
  /** #14 P1c/P2: the effective permission keys for the current user
   *  (group defaults + per-user overrides), feeding usePermissions(). */
  permissions: () => api.get<{ permissions: string[] }>('/auth/me/permissions'),
  /** Phase H0 #110: cheap status probe for the login page so it can
   *  decide whether to show the "Sign in with Microsoft" button. */
  ssoStatus: () => api.get<SsoStatus>('/auth/sso/status'),
};
